var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgChart3 = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "vector",
    d: "M1.16663 8.82241C1.16663 8.30536 1.58577 7.88623 2.1028 7.88623H3.97515C4.49218 7.88623 4.91133 8.30536 4.91133 8.82241V13.5033C4.91133 14.0203 4.49218 14.4395 3.97515 14.4395H2.1028C1.58577 14.4395 1.16663 14.0203 1.16663 13.5033V8.82241Z",
    fill: "currentColor"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vector_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.47168 5.07808C6.47168 4.56105 6.89082 4.14191 7.40786 4.14191H9.28021C9.79726 4.14191 10.2164 4.56105 10.2164 5.07808V13.5037C10.2164 14.0207 9.79726 14.4398 9.28021 14.4398H7.40786C6.89082 14.4398 6.47168 14.0207 6.47168 13.5037V5.07808Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0886 2.26967C12.0886 1.75264 12.5078 1.3335 13.0248 1.3335H14.8972C15.4142 1.3335 15.8334 1.75264 15.8334 2.26967V13.5038C15.8334 14.0208 15.4142 14.44 14.8972 14.44H13.0248C12.5078 14.44 12.0886 14.0208 12.0886 13.5038V2.26967Z",
    fill: "currentColor"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgChart3);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Chart3.b5c8baa26734dbf4a6099bb576f0f94c.svg";